import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareS = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 13V15C6 16.6569 7.34315 18 9 18H15C16.6569 18 18 16.6569 18 15V13M11.9995 13V6M11.9995 6L9 9M11.9995 6L15 9.00048",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShareS;
